import { captureException as captureSentryException } from "@/sentry";

export function captureException(error: unknown) {
	captureSentryException(error);
	console.error("error: ", error);
}
